import { useEffect, useState } from "react";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed right-4 md:right-8 bottom-6 md:bottom-10 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 cursor-pointer hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default BackToTop;